<template>
    <div>
        <v-simple-table v-if="getSpecificPeriodsDiffs(diff.diffs, 'add&update').length > 0"
                        v-for="contactDiff in getSpecificPeriodsDiffs(diff.diffs, 'add&update')"
                        class="my-3">
            <tr>
                <td v-if="contactDiff.old === null" width="40%"
                    :style="'background-color:' + addColors.light">
                </td>

                <td v-else width="40%" :style="'background-color:' + getPeriodColors(contactDiff).light">
                    <contact-diff-card :contactDiff="contactDiff" :data="contactDiff.old"></contact-diff-card>
                </td>

                <td width="20%" :style="'background-color:' + getPeriodColors(contactDiff).light">
                    <icons-between-columns :diff="contactDiff"></icons-between-columns>
                </td>

                <td v-if="contactDiff.new === null" width="40%">
                </td>
                <td v-else width="40%" :style="'background-color:' + getPeriodColors(contactDiff).light">
                    <contact-diff-card :contactDiff="contactDiff" :data="contactDiff.new"></contact-diff-card>
                </td>
            </tr>
        </v-simple-table>

        <div v-if="getSpecificPeriodsDiffs(diff.diffs, 'delete').length > 0">
            <v-expansion-panels>
                <v-expansion-panel :style="'background-color:' + deleteColors.light">
                    <v-expansion-panel-header :style="'background-color:' + deleteColors.light">
                                <span class="text-danger">
                            <v-icon color="red">delete_outline</v-icon>
                            Les contacts suivants ont été supprimés :
                        </span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <div class="d-flex">
                            <div v-for="contactDiff in getSpecificPeriodsDiffs(diff.diffs, 'delete')">
                                <contact-diff-card :contactDiff="contactDiff"
                                                   :data="contactDiff.old"></contact-diff-card>
                            </div>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </div>
    </div>
</template>

<script>

import IconsBetweenColumns from "./cardDiffsComponents/IconsBetweenColumns.vue"
import ContactDiffCard from "./cardDiffsComponents/ContactDiffCard.vue"
import { mapState } from "vuex"

export default {
    name: "ContactFieldDiffs",
    props: ["diff"],
    components: {
        IconsBetweenColumns,
        ContactDiffCard,
    },
    methods: {
        getSpecificPeriodsDiffs(diffs, type) {
            if (type === "add&update") {
                return diffs.filter(diff => diff.type === "ADDED" || diff.type === "UPDATED")
            } else if (type === "delete") {
                return diffs.filter(diff => diff.type === "DELETED")
            }
        },
        getPeriodColors(openingDiff) {
            if (openingDiff.old === null) {
                return this.addColors
            } else if (openingDiff.new !== null) {
                return this.updateColors
            } else {
                return this.deleteColors
            }
        },
    },
    computed: {
        ...mapState("sitAnswer", [
            "addColors",
            "updateColors",
            "deleteColors",
        ]),
    },
}
</script>